import { Injectable, OnDestroy } from '@angular/core';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import InstantSearch from 'instantsearch.js/es/lib/InstantSearch';
import type { Widget, IndexWidget } from 'instantsearch.js';
import { ALGOLIA_CONFIG } from './algolia.config';
import { AlgoliaSearchResults } from 'app/components/new-navigation/keyword-contextual-search/ais-widgets/search.types';

const searchClient = algoliasearch(ALGOLIA_CONFIG.appId, ALGOLIA_CONFIG.apiKey);

@Injectable({ providedIn: 'root' })
export class InstantSearchService implements OnDestroy {
  private started = false;

  readonly instance = new InstantSearch({
    searchClient,
    indexName: ALGOLIA_CONFIG.indices.apps,
    future: { preserveSharedStateOnUnmount: true }
  });

  ngOnDestroy() {
    this.instance.dispose();
  }

  // 👇 typed accessor for last results
  get lastResults(): AlgoliaSearchResults | undefined {
    return this.instance.helper?.lastResults as
      | AlgoliaSearchResults
      | undefined;
  }

  get params(): string {
    return this.lastResults?.params ?? '';
  }

  // Guard against calling start() more than once
  start() {
    if (!this.started) {
      this.started = true;
      this.instance.start();
    }
  }

  addWidgets(w: Array<Widget | IndexWidget>) {
    this.instance.addWidgets(w);
  }
  removeWidgets(w: Array<Widget | IndexWidget>) {
    this.instance.removeWidgets(w);
  }
}
